angular.module("avlib").directive("avIfHasAddress", ["countryConst", function(countryConst){
	return {
		restrict: 'A',
		link: function(scope, elem, attrs, ctrl){

			var invert = attrs.avIfNot != undefined;

			scope.$watch(attrs.avIfHasAddress, function(){
				var address = scope.$eval(attrs.avIfHasAddress);

				var hasData = false;
				if (address != null){
					hasData = (address.country != null && address.country.id != countryConst.BRAZIL)
						|| address.street || address.street_number
						|| address.apartment || address.district || (address.city && address.city.id) || (address.state && address.state.id)
						|| address.zip_code || address.address_directions || address.foreign_address || (address.latitude && address.longitude);
					hasData = hasData != undefined && hasData != null;
				}
				if (invert){
					if (hasData){
						$(elem).addClass('av-address-hidden');
					}else{
						$(elem).removeClass('av-address-hidden');
					}
				}else{
					if (!hasData){
						$(elem).addClass('av-address-hidden');
					}else{
						$(elem).removeClass('av-address-hidden');
					}
				}
			}, true);
		},
	};
}]);
